import List from '../../../../components/Operations/Engineering/QC/List'
import PageTitle from '../../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function QC(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item>Operations</Breadcrumb.Item>
              <Breadcrumb.Item>Engineering</Breadcrumb.Item>
              <Breadcrumb.Item href="#/operations/engineering/qc/list">
                QC Documents
              </Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'QC Documents'}
              subtitle={'Register of QC Documents'}
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

QC.propTypes = {}
QC.defaultProps = {}

export default QC
